// extracted by mini-css-extract-plugin
export default {"wrap":"OrdersOrdersComponent_wrap__HG+Dc","menuBlock":"OrdersOrdersComponent_menuBlock__8KuJ9","listBlock":"OrdersOrdersComponent_listBlock__Pv0a0"};